import React, { useEffect, useState } from "react";
import {
  AdminNavigation,
  Title,
  Input,
  Button,
  Modal,
  MenuBar,
} from "../../../components";
// import styles from "./styles.module.css";
import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useToast, CircularProgress, Center } from "@chakra-ui/react";
import { FaWrench, FaTrashAlt } from "react-icons/fa";
import {
  addPriority,
  editPriority,
  fetchPrioritys,
  removePriority,
} from "../../../redux/actions/admin/priorityActions";
import {
  CREATE_PRIORITY_RESET,
  DELETE_PRIORITY_RESET,
  UPDATE_PRIORITY_RESET,
} from "../../../redux/constants/admin/priorityConstants";

const Priority = () => {
  const ptitle = "Priority";
  const dispatch = useDispatch();
  const toast = useToast();
  //   const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [level, setLevel] = useState("");
  const [id, setID] = useState(null);

  useEffect(() => {
    dispatch(fetchPrioritys());
  }, [dispatch]);

  const openHandler = () => {
    setOpen(true);
    setEdit(false);
    setLevel("");
  };

  // states
  const createPriority = useSelector((state) => state.createPriority);
  const { loading, error, success } = createPriority;
  const updatePriority = useSelector((state) => state.updatePriority);
  const {
    loading: uLoading,
    error: uError,
    success: uSuccess,
  } = updatePriority;
  const deletePriority = useSelector((state) => state.deletePriority);
  const {
    loading: dLoading,
    error: dError,
    success: dSuccess,
  } = deletePriority;
  const getAllPrioritys = useSelector((state) => state.getAllPrioritys);
  const { prioritys = [] } = getAllPrioritys;

  const columns = [{ title: "Priority", field: "level" }];

  const deleteHandler = (id) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete this ${ptitle}`,
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(removePriority(id));
      }
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!level) {
      toast({
        title: "Warning!",
        description: "Enter Level",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(addPriority(level));
    }
  };

  const editHandler = (e) => {
    e.preventDefault();
    if (!level) {
      toast({
        title: "Warning!",
        description: "Enter Level",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(editPriority(level, id));
    }
  };

  if (error || uError || dError) {
    toast({
      title: "Error",
      description: error || uError || dError,
      status: "error",
      duration: 9000,
      isClosable: true,
    });
    error && dispatch({ type: CREATE_PRIORITY_RESET });
    uError && dispatch({ type: UPDATE_PRIORITY_RESET });
    dError && dispatch({ type: DELETE_PRIORITY_RESET });
  }

  if (success || uSuccess || dSuccess) {
    toast({
      title: "Notification",
      description: `Sucesss`,
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    setOpen(false);
    dispatch(fetchPrioritys());
    success && dispatch({ type: CREATE_PRIORITY_RESET });
    uSuccess && dispatch({ type: UPDATE_PRIORITY_RESET });
    dSuccess && dispatch({ type: DELETE_PRIORITY_RESET });
  }

  // Menubar Items
  const menu = [
    { name: "Helpdesk Teams", url: "/admin/config" },
    { name: "Ticket Type", url: "/admin/config/ticketType" },
    { name: "Stages", url: "/admin/config/stages" },
    { name: "Stage Level", url: "/admin/config/stagelevel" },
    { name: "SLA Policies", url: "/admin/config/sla" },
    { name: "Priority", url: "/admin/config/priority", active: true },
    { name: "Tag", url: "/admin/config/tag" },
    { name: "Exclude Stage", url: "/admin/config/excludeStage" },
  ];

  return (
    <div className="appContainer">
      <AdminNavigation />
      <div className="contentsRight">
        <Title title={ptitle} type="Admin" />
        <MenuBar menu={menu} />
        <div className="btnContainer right">
          <button type="button" onClick={openHandler} className="btn teal">
            Add {ptitle}
          </button>
        </div>
        {dLoading ? (
          <Center>
            <CircularProgress isIndeterminate color="#3AB29A" />
          </Center>
        ) : (
          <MaterialTable
            title=""
            columns={columns}
            data={prioritys}
            options={{
              exportAllData: true,
              exportButton: true,
              actionsCellStyle: {
                backgroundColor: "none",
                color: "#FF00dd",
              },
              actionsColumnIndex: -1,

              headerStyle: {
                backgroundColor: "#dcdcdc",
                color: "black",
                fontWeight: "bold",
              },
            }}
            style={{
              boxShadow: "none",
              width: "100%",
              background: "none",
              fontSize: "13px",
            }}
            actions={[
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Update",
                onClick: (event, rowData) => {
                  setOpen(true);
                  setEdit(true);
                  setLevel(rowData.level);
                  setID(rowData.id);
                },
                title: "Update",
                color: "teal",
                Icon: FaWrench,
              },
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  deleteHandler(rowData.id);
                },
                title: "Delete",
                color: "gold",
                Icon: FaTrashAlt,
              },
            ]}
            components={{
              Action: (props) => (
                <button
                  onClick={(event) => props.action.onClick(event, props.data)}
                  className={`btnTable ${props.action.color}`}
                >
                  <props.action.Icon />
                  {props.action.title}
                </button>
              ),
            }}
          />
        )}
        <Modal
          isVisible={open}
          title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
          size="lg"
          content={
            <form onSubmit={edit ? editHandler : submitHandler}>
              <div className="nirsal__InputFlex">
                <Input
                  type="text"
                  onChange={(e) => setLevel(e.target.value)}
                  value={level}
                  required={true}
                  title="Level"
                  size="large"
                />
                <Button
                  title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
                  type="submit"
                  isFullWidth={true}
                  size="lg"
                  loading={loading || uLoading}
                />
              </div>
            </form>
          }
          onClose={() => setOpen(false)}
        />
      </div>
    </div>
  );
};

export default Priority;
